import bgVideo from "../../assets/video/intro_video_sswhite.mp4";
//import bgVideo from "../../assets/video/under_development.mp4";
import logo180 from "../../assets/images/years_logo_gold.svg";
import logoShukla from "../../assets/images/shukla_medical_logo.png";
import logoSSW from "../../assets/images/ssw_logonew.svg";

import React, { useEffect, useRef, useState } from 'react';
// Round M1 — mobile/responsive overrides for this page (scoped by .login-* classes).
import "../../assets/styles/login-responsive.css";
import { Input, Label, FormFeedback, Alert } from 'reactstrap';
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import api from "../../api";   // Round 17: public help-info
import * as Yup from "yup";
import { useFormik } from "formik";
import { loginUser, googleLoginUser, resetLoginFlag } from "../../slices/thunks";   // Round 21: Google

const Login = (props) => {
    const dispatch = useDispatch();
    const videoRef = useRef(null);

    // If a user is already logged in (in this browser), do NOT show the login
    // form — send them to the dashboard. This makes a new tab / the login URL
    // land directly in the app when a session exists, and prevents a DIFFERENT
    // person from signing in over an active session. Log out first to switch users.
    useEffect(() => {
        try {
            const existing = sessionStorage.getItem("authUser")
                || localStorage.getItem("persist:authUser");
            if (existing) {
                props.router.navigate("/dashboard", { replace: true });
            }
        } catch (e) { /* ignore */ }
        
    }, []);

    const { error, loading } = useSelector(state => ({
        error: state.Login.error,
        loading: state.Login.loading,
    }));
    const { errorMsg } = useSelector(state => state.Login);

    const [passwordShow, setPasswordShow] = useState(false);

    // Round M1 — do NOT download/play the large background video on narrow
    // screens or when the user prefers reduced motion. The page falls back to
    // a static gradient (see .login-root in login-responsive.css). Desktop
    // behavior is unchanged.
    const [showVideo, setShowVideo] = useState(() => {
        try {
            return window.matchMedia("(min-width: 768px)").matches
                && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        } catch (e) { return true; }
    });
    useEffect(() => {
        try {
            const mqWide = window.matchMedia("(min-width: 768px)");
            const mqMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
            const update = () => setShowVideo(mqWide.matches && !mqMotion.matches);
            const add = (mq) => mq.addEventListener ? mq.addEventListener("change", update) : mq.addListener(update);
            const remove = (mq) => mq.removeEventListener ? mq.removeEventListener("change", update) : mq.removeListener(update);
            add(mqWide); add(mqMotion);
            return () => { remove(mqWide); remove(mqMotion); };
        } catch (e) { /* ignore */ }
    }, []);

    /* slow down video */
    useEffect(() => {
        if (videoRef.current) videoRef.current.playbackRate = 0.6;
    }, []);

    /* placeholder colour fix */
    useEffect(() => {
        const s = document.createElement('style');
        s.id = 'login-ph-fix';
        s.innerHTML = `
            #emailOrEmpId::placeholder,
            #password-input::placeholder { color: rgba(255,255,255,0.55) !important; opacity:1 !important; }
            #emailOrEmpId, #password-input {
                color: #fff !important;
                background: rgba(255,255,255,0.14) !important;
                border: 1px solid rgba(255,255,255,0.30) !important;
                border-radius: 8px !important;
            }
            #emailOrEmpId:focus, #password-input:focus {
                background: rgba(255,255,255,0.20) !important;
                border-color: rgba(255,255,255,0.55) !important;
                box-shadow: none !important;
            }
        `;
        document.head.appendChild(s);
        return () => document.getElementById('login-ph-fix')?.remove();
    }, []);

    useEffect(() => {
        if (errorMsg) setTimeout(() => dispatch(resetLoginFlag()), 3000);
    }, [dispatch, errorMsg]);

    // Round 17: how employees without e-mail reach IT (Support:ItHelpText, public).
    const [itHelpText, setItHelpText] = useState("");
    // Round 21: Google sign-in configuration (public: enabled flag + Client ID + domain).
    const [googleCfg, setGoogleCfg] = useState(null);
    const googleBtnRef = useRef(null);
    const rememberRef = useRef(false);
    useEffect(() => {
        let alive = true;
        api.get("Auth/help-info").then((r) => {
            if (!alive) return;
            if (r?.data?.itHelpText) setItHelpText(r.data.itHelpText);
            if (r?.data?.google?.enabled && r.data.google.clientId) setGoogleCfg(r.data.google);
        }).catch(() => {});
        return () => { alive = false; };
    }, []);

    // Round 21: load Google Identity Services once and render the official button.
    // Google hands back an ID token (JWT) for the chosen account; the API verifies it
    // against Google's public keys, our Client ID and the company domain, then maps
    // the e-mail to the employee record. No password is involved.
    useEffect(() => {
        if (!googleCfg || !googleBtnRef.current) return undefined;
        let cancelled = false;
        const render = () => {
            if (cancelled || !window.google?.accounts?.id || !googleBtnRef.current) return;
            try {
                window.google.accounts.id.initialize({
                    client_id: googleCfg.clientId,
                    callback: (resp) => {
                        if (resp?.credential) dispatch(googleLoginUser(resp.credential, rememberRef.current, props.router.navigate));
                    },
                    hd: googleCfg.hostedDomain || undefined,
                    ux_mode: "popup",
                    auto_select: false,
                    itp_support: true,
                });
                googleBtnRef.current.innerHTML = "";
                window.google.accounts.id.renderButton(googleBtnRef.current, {
                    theme: "outline", size: "large", shape: "pill", text: "signin_with", width: 300, logo_alignment: "left",
                });
            } catch (e) { /* the password form still works */ }
        };
        if (window.google?.accounts?.id) { render(); }
        else {
            const existing = document.getElementById("google-gsi-script");
            const script = existing || document.createElement("script");
            if (!existing) {
                script.id = "google-gsi-script";
                script.src = "https://accounts.google.com/gsi/client";
                script.async = true; script.defer = true;
                document.head.appendChild(script);
            }
            script.addEventListener("load", render);
            return () => { cancelled = true; script.removeEventListener("load", render); };
        }
        return () => { cancelled = true; };
       
    }, [googleCfg]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: { emailOrEmpId: '', password: '', rememberMe: false },   // Round 8: bounded remember-me
        validationSchema: Yup.object({
            emailOrEmpId: Yup.string().required("Please enter your Email or Emp ID"),
            password: Yup.string().required("Please enter your Password"),
        }),
        onSubmit: (values) => dispatch(loginUser(values, props.router.navigate)),
    });

    document.title = "SSW Technologies";

    return (
        <div className="login-root" style={s.root}>

            {/* Background video — desktop only (see showVideo above) */}
            {showVideo && (
                <video ref={videoRef} autoPlay loop muted playsInline className="login-video" style={s.video}>
                    <source src={bgVideo} type="video/mp4" />
                </video>
            )}

            {/* Centred card */}
            <div className="login-cardwrap" style={s.cardWrap}>
                <div className="login-card" style={s.card}>

                    <h2 style={s.heading}>Log In</h2>
                    <p style={s.subheading}>Please fill the details &amp; continue to login.</p>

                    {errorMsg && (
                        <Alert color="danger" style={{ fontSize: 13, marginBottom: '1rem' }}>
                            {errorMsg}
                        </Alert>
                    )}

                    <form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>

                        {/* Email / Emp ID */}
                        <div style={{ marginBottom: '1rem' }}>
                            <Label htmlFor="emailOrEmpId" style={s.label}>Email or Emp ID</Label>
                            <Input
                                name="emailOrEmpId"
                                id="emailOrEmpId"
                                placeholder="Enter Email or Emp ID"
                                type="text"
                                autoComplete="username"
                                autoCapitalize="none"
                                autoCorrect="off"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.emailOrEmpId || ""}
                                invalid={validation.touched.emailOrEmpId && !!validation.errors.emailOrEmpId}
                            />
                            {validation.touched.emailOrEmpId && validation.errors.emailOrEmpId && (
                                <FormFeedback>{validation.errors.emailOrEmpId}</FormFeedback>
                            )}
                        </div>

                        {/* Password */}
                        <div style={{ marginBottom: '0.5rem' }}>
                            <Label htmlFor="password-input" style={s.label}>Password</Label>
                            <div style={{ position: 'relative' }}>
                                <Input
                                    name="password"
                                    id="password-input"
                                    value={validation.values.password || ""}
                                    type={passwordShow ? "text" : "password"}
                                    placeholder="Enter Password"
                                    autoComplete="current-password"
                                    style={{ paddingRight: '2.5rem' }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.password && !!validation.errors.password}
                                />
                                {validation.touched.password && validation.errors.password && (
                                    <FormFeedback>{validation.errors.password}</FormFeedback>
                                )}
                                <button
                                    type="button"
                                    onClick={() => setPasswordShow(!passwordShow)}
                                    style={s.eyeBtn}
                                >
                                    <i className={`ri-${passwordShow ? 'eye-off' : 'eye'}-fill`} />
                                </button>
                            </div>
                        </div>

                        {/* Forgot password / setup code (Round 17: employees without e-mail) */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginBottom: '0.75rem', flexWrap: 'wrap' }}>
                            <Link to="/setup-code" style={s.link} title="For employees without an e-mail address: the IT team gives you a setup code">I have a setup code</Link>
                            <Link to="/forgot-password" style={s.link}>Forgot password?</Link>
                        </div>
                        {itHelpText && (
                            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: '0.75rem' }}>
                                No e-mail address? {itHelpText}
                            </div>
                        )}

                        {/* Remember me */}
                        <label style={s.rememberRow} title="Keeps you signed in on this device for up to 14 days (the session still ends if your password, role or status changes).">
                            <input type="checkbox" name="rememberMe" style={{ accentColor: '#1a3a8f' }}
                                   checked={!!validation.values.rememberMe}
                                   onChange={(e) => { validation.setFieldValue("rememberMe", e.target.checked); rememberRef.current = e.target.checked; }} />
                            <span style={{ ...s.label, marginBottom: 0 }}>Remember me</span>
                        </label>

                        {/* ── Submit button — plain <button> avoids Reactstrap override ── */}
                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                ...s.loginBtn,
                                opacity: loading ? 0.75 : 1,
                                cursor: loading ? 'not-allowed' : 'pointer',
                            }}
                        >
                            {loading ? (
                                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                                    {/* native CSS spinner — no dependency */}
                                    <span style={s.spinner} />
                                    Logging in…
                                </span>
                            ) : (
                                'Login'
                            )}
                        </button>

                    </form>

                    {/* Round 21: Sign in with Google (only when enabled on the API) */}
                    {googleCfg && (
                        <div style={{ marginTop: 14 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: '#9aa3b5', fontSize: 12, margin: '6px 0 10px' }}>
                                <span style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.15)' }} />
                                or{googleCfg.hostedDomain ? ` — with your @${googleCfg.hostedDomain} account` : ""}
                                <span style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.15)' }} />
                            </div>
                            <div ref={googleBtnRef} style={{ display: 'flex', justifyContent: 'center', minHeight: 44 }} />
                        </div>
                    )}
                </div>
            </div>

            {/* Footer logo bar */}
            <div className="login-footer" style={s.footer}>
                <div className="login-footer-inner" style={s.footerInner}>
                    <img src={logoShukla} alt="Shukla Medical" className="login-footer-logo" style={s.footerLogo} />
                    <div className="login-divider" style={s.divider} />
                    <img src={logo180} alt="180 Years SSW" className="login-footer-logo" style={{ ...s.footerLogo, maxHeight: 52 }} />
                    <div className="login-divider" style={s.divider} />
                    <img src={logoSSW} alt="S.S. White Technologies" className="login-footer-logo" style={s.footerLogo} />
                </div>
            </div>

        </div>
    );
};

/* ─── Styles ────────────────────────────────────────────── */
const s = {
    root: {
        position: 'relative',
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        objectFit: 'cover',
    },
    video: {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        imageRendering: 'high-quality',   // ← add this
        transform: 'translateZ(0)',        // ← forces GPU rendering = sharper
        willChange: 'transform',           // ← tells browser to optimize
    },
    // video: {
    //     position: 'absolute',
    //     inset: 0,
    //     width: '100%',
    //     height: '100%',
    //     objectFit: 'cover',
    // },
    cardWrap: {
        position: 'relative',
        zIndex: 10,
        width: '100%',
        maxWidth: 440,
        padding: '0 1rem',
        marginBottom: 80,
    },
    card: {
        background: 'rgba(0,0,0,0.52)',
        backdropFilter: 'blur(22px)',
        WebkitBackdropFilter: 'blur(22px)',
        border: '1px solid rgba(255,255,255,0.18)',
        borderRadius: 16,
        padding: '2.25rem 2rem 2rem',
        boxShadow: '0 8px 40px rgba(0,0,0,0.50)',
    },
    heading: {
        color: '#fff',
        fontSize: 26,
        fontWeight: 600,
        textAlign: 'center',
        margin: '0 0 0.25rem',
    },
    subheading: {
        color: 'rgba(255,255,255,0.65)',
        fontSize: 13,
        textAlign: 'center',
        margin: '0 0 1.5rem',
    },
    label: {
        display: 'block',
        color: 'rgba(255,255,255,0.85)',
        fontSize: 13,
        fontWeight: 500,
        marginBottom: '0.35rem',
    },
    eyeBtn: {
        position: 'absolute',
        right: 10,
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'none',
        border: 'none',
        color: 'rgba(255,255,255,0.7)',
        cursor: 'pointer',
        padding: 0,
        lineHeight: 1,
        zIndex: 2,
    },
    link: {
        color: 'rgba(255,255,255,0.65)',
        fontSize: 13,
        textDecoration: 'underline',
    },
    rememberRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        cursor: 'pointer',
        marginBottom: '1.25rem',
    },
    loginBtn: {
        width: '100%',
        padding: '0.65rem',
        fontSize: 15,
        fontWeight: 600,
        borderRadius: 8,
        background: '#1a3a8f',
        border: 'none',
        color: '#fff',
        letterSpacing: '0.02em',
        transition: 'opacity 0.2s',
    },
    /* Pure CSS spinner — no Reactstrap Spinner needed */
    spinner: {
        display: 'inline-block',
        width: 16,
        height: 16,
        border: '2px solid rgba(255,255,255,0.35)',
        borderTopColor: '#fff',
        borderRadius: '50%',
        animation: 'spin 0.7s linear infinite',
    },
    /* Footer */
    footer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 20,
        background: 'rgba(180,180,185,0.25)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderTop: '1px solid rgba(255,255,255,0.12)',
        padding: '0.75rem 2rem',
    },
    footerInner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2.5rem',
        maxWidth: 900,
        margin: '0 auto',
    },
    footerLogo: {
        maxHeight: 44,
        maxWidth: 200,
        objectFit: 'contain',
        filter: 'brightness(1.1)',
    },
    divider: {
        width: 1,
        height: 40,
        background: 'rgba(255,255,255,0.20)',
    },
};

/* Inject keyframe for spinner (once) */
if (!document.getElementById('login-spin-kf')) {
    const kf = document.createElement('style');
    kf.id = 'login-spin-kf';
    kf.innerHTML = `@keyframes spin { to { transform: rotate(360deg); } }`;
    document.head.appendChild(kf);
}

export default withRouter(Login);